/*
 * @Author: your name
 * @Date: 2022-03-05 17:08:20
 * @LastEditTime: 2022-08-12 20:47:04
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyUserThumbList\index.jsx
 */
import React, { Component } from 'react';

import './index.css'
import { BsyUtils } from '../../utils/Utils';
import { dayjsUtils } from '../../utils/dayjsUtils';

export default class BsyDeptUserPane extends Component {
    static defaultProps = {
        type: 'user',
        status: '',
        info: {}
    }
    constructor(props) {
        super(props);
        this.state = {
            type: props.type,
            info: props.info,
            status: props.status,
        }
    }


    renderDept = () => {
        const { info, status } = this.state;
        return (<>
            <div className="dept-view-popover-content">
                <div className="dept-content-title">{status === 'deleted' ? `${React.language('department.ownership')}(${React.language('before.del')})` : React.language('department.ownership')}</div>
                <div className={"dept-content-info " + status}  >{info.deptname}</div>
            </div>
        </>)
    }

    renderMember = () => {
        const { info, type } = this.state;
        const bg = BsyUtils.formatUserThumb(info.nickname)
        return (<>
            <div className="user-header">
                {type === 'user' && <div className="user-avatar">
                    {info.avatarurl ? <img src={info.avatarurl} alt="" /> : <span className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></span>}
                </div>}
                <div className="user-name-type" style={{width: type === 'user' ? 'calc(100% - 50px)' : '100%'}}>
                    <div className="user-status">
                        <div className="user-name" title={info.nickname || info.name || ''} >
                            {
                                info.nickname || info.name || ''
                            }
                        </div>
                        {
                            (info.status == -2 || info.status == -99) && <div className="user-type red" >
                                {
                                    info.status == -2 ? info.mode === 'outsider' ? React.language('deleted') : React.language('resigned') : React.language('deleted')
                                }
                            </div>
                        }
                    </div>
                    {type === 'user' && <div className="user-type" >
                        {
                            info.mode === 'member' ? React.language('organization.internal.user') : info.mode === 'dock_user' ? React.language('organization.external.user') : info.mode === 'outsider' ? React.language('outsider') : React.language('outside')
                        }
                    </div>}
                </div>
            </div>
            <div className="user-info">
                {
                    (type === 'user' && (info.deptname || info.groupname || info.main_deptName)) && <div className="user-deptname">
                        <span className="user-title">{React.language('department')}</span>
                        <span className="info" title={(info.main_deptName ? info.main_deptName : "") + (info.deptName ? "," + info.deptName : "")} >{info.main_deptName && <b><i className="icon-bsy-main-dept"></i>{info.main_deptName}</b>}{info.deptname || info.groupname} </span>
                    </div>
                }
                {
                    info.mobile && <div className="user-mobile">
                        <span className="user-title">{React.language('phone')}</span>
                        <span className="info" title={info.Country_code ? ('+'+info.Country_code + info.mobile) : info.mobile}>{info.Country_code ? ('+'+info.Country_code + info.mobile) : info.mobile} </span>
                    </div>
                }
                {
                    info.email && <div className="user-email">
                        <span className="user-title">{React.language('email')}</span>
                        <span className="info" title={info.email}>{info.email} </span>
                    </div>
                }
                {
                    info.path && <div className="user-email">
                        <span className="user-title">{React.language('department.ownership')}</span>
                        <span className="info" title={info.path}>{info.path} </span>
                    </div>
                }
                {
                    info.job_title && <div className="user-email">
                        <span className="user-title">{React.language('Title')}</span>
                        <span className="info" title={info.job_title}>{info.job_title} </span>
                    </div>
                }
                {
                    info.role && <div className="user-email">
                        <span className="user-title">{React.language('role')}</span>
                        <span className="info" title={info.role}>{info.role} </span>
                    </div>
                }
                {
                    info.uniqueid && <div className="user-email">
                        <span className="user-title">{React.language('enterprise.user.id')}</span>
                        <span className="info" title={info.uniqueid}>{info.uniqueid} </span>
                    </div>
                }
                {
                    info.remark && <div className="user-email">
                        <span className="user-title">{React.language('contact.note')}</span>
                        <span className="info" title={info.remark}>{info.remark} </span>
                    </div>
                }
                {
                    info.join_time && <div className="user-email">
                        <span className="user-title">{React.language('join.time')}</span>
                        <span className="info" title={info.join_time}>{info.join_time} </span>
                    </div>
                }
                {
                    info.user_id && <div className="user-email">
                        <span className="user-title">userId</span>
                        <span className="info" title={info.user_id}>{info.user_id} </span>
                    </div>
                }
                {
                    info.leave_time && <div className="user-email">
                        <span className="user-title">{React.language('resign.time')}</span>
                        <span className="info" title={BsyUtils.date2Str(dayjsUtils.timeToTZ(info.leave_time), "yyyy-MM-dd HH:mm:ss")}>
                            {BsyUtils.date2Str(dayjsUtils.timeToTZ(info.leave_time), "yyyy-MM-dd HH:mm:ss")} </span>
                    </div>
                }

            </div>
        </>)
    }


    render() {
        const { type } = this.state
        return (
            <div className={"bsy-dept-user-pane " + type} >
                {
                    this.renderMember()
                }
            </div>
        );
    }
}
